module.exports = __webpack_public_path__ + "static/media/logo-monochrome-small.33a2522e.svg";